import './App.css';
import Menu from './Menu';
import Philosophy from './Philosophy';
import Works from './Works';
import Footer from './Footer';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from "./theme";

/*
  #e7e6e1
  #f7f6e7
  #314e52
  #f2a154
*/
function App() {
  return (
    <ThemeProvider theme={theme}>
    <div className="App" style={{backgroundColor: "#f7f6e7"}}>
      <Menu />
      <Philosophy />
      <Works />
      <Footer />
    </div>
    </ThemeProvider>
  );
}

export default App;
